<template>
  <div class="table-item">
    <div class="title clearfix">
      <p class="pull-left userInfo type-title">{{ title }}</p>
      <div class="pull-right">
        <slot name="tool"></slot>
      </div>
    </div>

    <div class="table">
      <el-table
        :data="tableData"
        stripe
        border
        style="width: 100%"
        ref="eltable"
        :summary-method="summaryMethod"
        :show-summary="showSummary"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="index"
          width="100"
          label="序号"
        ></el-table-column>
        <el-table-column
          :prop="item.field"
          :label="item.label"
          min-width="200"
          v-for="(item, index) of columnData"
          :key="index"
          v-if="!['infoLine'].includes(item.class)"
        >
          <template slot-scope="scope">
            <el-button
              class="textBtn"
              v-if="item.tabletype == 'anyDo'"
              @click.native.prevent="anyDoRow(scope, item)"
              type="text"
              size="small"
              >{{ getAuditBtnText(scope, item) }}</el-button
            >

            <el-tag v-else-if="item.tabletype == 'tags'" type="success">{{
              scope.row[item.field]
            }}</el-tag>
            <el-tag
              v-else-if="item.tabletype == 'listTags'"
              :type="listTags[scope.row[item.field]][0]"
              >{{ listTags[scope.row[item.field]][1] }}</el-tag
            >
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </el-table-column>
        <slot name="other"></slot>
        <el-table-column fixed="right" label="操作" width="200" v-if="isEdit">
          <template slot-scope="scope">
            <el-button
              class="textBtn"
              @click.native.prevent="editRow(scope)"
              type="text"
              size="small"
              >{{ text }}</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="lookDetail(scope)"
              v-show="!isFundShow && isLookShow"
              >查看项目</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
// 导航栏
const leftWidth = 250;
const cellWidth = 200;

export default {
  // props: ["title", "flag", "tableData", "columnData"],
  props: {
    title: String,
    flag: Number,
    tableData: Array,
    columnData: Array,
    isEdit: {
      default: true,
    },
    text: {
      default: "详情",
    },
    summaryMethod: {},
    showSummary: {
      default: false,
    },
    isBackShow: {
      default: false,
    },
    isLookShow: {
      default: false,
    },
  },

  data() {
    return {
      listTags: {
        0: ["info", "未提交"],
        1: ["", "待审核"],
        2: ["warning", "审核中"],
        3: ["success", "已通过"],
        4: ["danger", "未通过"],
      },
      isFundShow: false,
    };
  },

  computed: {
    columnWidth() {
      const width = document.body.clientWidth - leftWidth;
      const maxLength = width / cellWidth;
      if (maxLength >= this.columnData.length) return "auto";
      else return cellWidth;
    },
  },

  methods: {
    //合计行
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },

    editRow(scope) {
      this.$emit("editTable", {
        flag: this.flag,
        scope,
      })
      setTimeout(()=>{ this.$emit("editTable", {
        flag: this.flag,
        scope,
      })},300)
    },

    anyDoRow(scope, item) {
      if (item.label == "审核意见") {
        let data = scope.row[item.field];

        if (data !== "未通过") return;
      }
      this.$emit("anyDoRow", {
        item,
        scope,
      });
    },

    handleSelectionChange(val) {
      if (val.length) {
        let ids = [];
        val.forEach((item) => {
          ids.push(item.id);
        });
        this.$emit("handleSelectionChange", ids.join(","), this.flag);
      }
      this.$emit("handleSelectionCode", val);
    },
    // 审核
    getAuditBtnText(scope, item) {
      if (item.label == "审核意见") {
        let data = scope.row[item.field];
        // console.log("TCL: getAuditBtnText -> data", data);
        if (data == "未通过") return item.typeField.split("/")[0];
        else return "--";
      }
      return item.typeField.split("/")[0];
    },
    //查看详情
    lookDetail(scope) {
      const codeId = scope.row.id;
      this.isFundShow = true;
      this.$emit("lookDetail", codeId, this.isFundShow);
    },
  },
  mounted() {
    this.$refs.eltable.doLayout();
  },
};
</script>

<style scoped lang="scss">
.title {
  padding-bottom: 20px;
}
.table-item {
  flex: 1;
  // margin-bottom: 20px;
  display: inherit;
  flex-direction: column;
  .table {
    flex: 1;
    ::v-deep .el-table {
      // height: 100%;
      .el-table__body-wrapper {
        // height: calc(100% - 71px);
      }
    }
  }
}
/* .el-tag {
  color: #3165ff;
  background: #dde6ff;
} */
.el-tag.el-tag--warning {
  border-color: #fff !important;
}
.isMust:after {
  content: "*";
  font-size: 14px;
  font-family: Alibaba;
  color: #ff2626;
}
</style>
